<template>
  <div id="RequestVam">
    <panel
      class="no-print"
      :Title="$GetIsAnbohSaz() == 'false' ? 'درخواست وام' : 'درخواست واحد'"
      :Des="
        $GetIsAnbohSaz() == 'false'
          ? 'از طریق این فرم می‌توانید درخواست وام خود را ثبت نمایید'
          : 'از طریق این فرم می‌توانید درخواست واحد خود را ثبت نمایید'
      "
      :IsBtnBack="true"
      ClassCustom="bg-dark-Custom text-right mt-2"
    ></panel>
    <net-pa-card class="no-print">
      <template slot="header">
        <h6 class="text-right">
          <i class="fas fa-hand-holding-usd"></i>
          {{ $GetIsAnbohSaz() == "false" ? "درخواست وام" : "درخواست واحد" }}
        </h6>
      </template>
      <template slot="content">
        <div v-if="showGhavaninVam" class="request-vam-rules vam-section" dir="rtl">
          <h5 class="request-vam-rules__title">
            <i class="fas fa-file-contract" aria-hidden="true"></i>
            قوانین و مقررات دریافت وام
          </h5>
          <p class="request-vam-rules__text">
            اظهار مینمایم که ذیحسابی سازمان خبرگزاری جمهوری اسلامی وکالت بلاعزل دارد معادل مبلغ وام پرداختی به انضمام
            کارمزد و هزینه های مزبور را بر اساس رقم و تعداد اقساطی که از سوی شرکت تعاونی به ذیحسابی اعلام میشود از حقوق
            و سایر مزایا و مطالبات اینجانب کسر و به حساب شرکت تعاونی واریز نماید. در ضمن متعهد می شوم چنانچه به هر دلیلی
            همکاری خود را با سازمان خبرگزاری جمهوری اسلامی اعم از دائم یا موقت (شامل مرخصی بدون حقوق ،آموزش، ماموریت و
            سایر موارد )قطع نمایم ضمن اعلام به شرکت ، کل مبلغ وام را یکجا تسویه نمایم و همچنین شرکت مختار است در صورت
            عدم دسترسی از ضامنین کسر نماید
          </p>
          <div class="vam-notice vam-notice--warning request-vam-review-terms">
            <input
              id="flexCheckIndeterminate"
              type="checkbox"
              v-model="isAcceptSharaytVam"
            />
            <label for="flexCheckIndeterminate">
              قوانین و مقررات را مطالعه نموده و قبول دارم
            </label>
          </div>
          <div class="request-vam-step-nav request-vam-step-nav--next-only request-vam-step-nav--narrow">
            <button
              type="button"
              :disabled="!isAcceptSharaytVam"
              class="request-vam-step-nav__btn request-vam-step-nav__btn--next"
              @click="showGhavaninVam = false"
            >
              مرحله بعد
              <i class="fa fa-arrow-left" aria-hidden="true"></i>
            </button>
          </div>
        </div>

        <template v-else>
          <div class="netpa-list-page-header">
            <nav
              ref="vamStepper"
              class="vam-stepper"
              :class="{ 'vam-stepper--compact': stepperCompact }"
              dir="rtl"
              aria-label="مراحل ثبت درخواست"
            >
              <ol class="vam-stepper__list">
                <li
                  v-for="(step, index) in vamSteps"
                  :key="step.id"
                  class="vam-stepper__item"
                  :class="{
                    'vam-stepper__item--active': divToShow === step.id,
                    'vam-stepper__item--completed': isStepCompleted(step.id),
                    'vam-stepper__item--locked': !canNavigateToStep(step.id),
                    'vam-stepper__item--last': index === vamSteps.length - 1,
                  }"
                >
                  <button
                    type="button"
                    class="vam-stepper__btn"
                    :disabled="!canNavigateToStep(step.id)"
                    :title="getStepTabTitle(step.id)"
                    :aria-current="divToShow === step.id ? 'step' : null"
                    @click="goToStep(step.id)"
                  >
                    <span class="vam-stepper__circle">
                      <i
                        v-if="isStepCompleted(step.id) && divToShow !== step.id"
                        class="fas fa-check"
                        aria-hidden="true"
                      ></i>
                      <span v-else>{{ step.id }}</span>
                    </span>
                    <span class="vam-stepper__label">{{ step.label }}</span>
                  </button>
                </li>
              </ol>
            </nav>
          </div>

          <div class="request-vam-content text-right py-3 px-0">
            <div v-if="divToShow == 1" class="request-vam-step-panel request-vam-step">
              <div
                class="request-vam-type-list"
                dir="rtl"
                role="radiogroup"
                :aria-label="$GetIsAnbohSaz() == 'false' ? 'نوع وام' : 'نوع واحد'"
              >
                <button
                  v-for="(item, key) in Vamha"
                  :key="key"
                  type="button"
                  role="radio"
                  :aria-checked="SelectedVam.id == item.id ? 'true' : 'false'"
                  class="request-vam-type-card"
                  :class="{ 'request-vam-type-card--selected': SelectedVam.id == item.id }"
                  @click="SelectedVam.id != item.id && seLectVam(item)"
                >
                  <span class="request-vam-type-card__radio" aria-hidden="true">
                    <i class="fas fa-check"></i>
                  </span>
                  <span class="request-vam-type-card__info">
                    <span class="request-vam-type-card__title">{{ item.desNoe }}</span>
                    <span v-if="item.tozihatForRequestVam" class="request-vam-type-card__desc">
                      {{ item.tozihatForRequestVam }}
                    </span>
                  </span>
                </button>
              </div>
              <div class="request-vam-step-nav request-vam-step-nav--next-only request-vam-step-nav--narrow">
                <button
                  type="button"
                  :disabled="Object.entries(SelectedVam).length === 0"
                  @click="nextPage(2)"
                  class="request-vam-step-nav__btn request-vam-step-nav__btn--next"
                >
                  مرحله بعد
                  <i class="fa fa-arrow-left" aria-hidden="true"></i>
                </button>
              </div>
            </div>

            <div v-if="divToShow == 2" class="request-vam-step-panel request-vam-step">
              <section class="vam-section">
                <div class="row request-vam-form-grid mx-0">
                  <div class="col-12 col-md-6 py-2 vam-f-amount">
                    <label for="MabVam" class="text-secondary"> مبلغ وام</label>
                    <input
                      type="text"
                      :disabled="SelectedVam.fixMablagh"
                      id="MabVam"
                      class="form-control text-left 3ragham"
                      v-model="vamDetail.MablaghVam"
                      @keyup="
                        $PutCommatoInput()
                        calculateMablaghghest()
                        CheckupSaghfVam($event)
                      "
                      @keypress="$ValidNumber($event, 15, false)"
                      dir="ltr"
                    />
                  </div>
                  <div class="col-12 col-md-6 py-2 request-vam-date-field vam-f-date">
                    <label for="NeedData" class="text-secondary d-block">تاریخ نیاز</label>
                    <date-picker
                      :disabled="$session.get('CustCode') == 868"
                      v-model="vamDetail.NeedData"
                      color="#f38905"
                    ></date-picker>
                    <input type="text" id="NeedData" v-model="vamDetail.NeedData" class="d-none InputText" dir="ltr" />
                  </div>
                  <div class="col-12 col-md-6 py-2 vam-f-count">
                    <label for="ghestNum" class="text-secondary"> تعداد قسط</label>
                    <input
                      v-if="$session.get('CustCode') != 868"
                      type="text"
                      @keyup="calculateMablaghghest"
                      :disabled="SelectedVam.fixTedad"
                      id="ghestNum"
                      v-model="vamDetail.TedadGhest"
                      class="form-control text-left"
                      maxlength="2"
                      @keypress="$ValidNumber($event, 12, false)"
                      dir="ltr"
                    />
                    <select
                      v-else
                      id="ghestNum"
                      class="form-control text-center"
                      v-model="vamDetail.TedadGhest"
                      @change="calculateMablaghghest($event)"
                    >
                      <option :value="24">24</option>
                      <option :value="36">36</option>
                      <option :value="48">48</option>
                    </select>
                  </div>
                  <div class="col-12 col-md-6 py-2 vam-f-installment" v-if="$session.get('CustCode') != 9">
                    <label for="ghestmab" class="text-secondary"> مبلغ قسط</label>
                    <input
                      disabled="disabled"
                      type="text"
                      id="ghestmab"
                      v-model="vamDetail.Mablaghghest"
                      class="form-control text-left 3ragham"
                    />
                  </div>
                  <div
                    class="col-12 col-md-6 py-2 vam-f-pay"
                    v-if="$session.get('CustCode') != 868 && $session.get('CustCode') != 8002"
                  >
                    <label class="text-secondary"> نحوه پرداخت وام</label>
                    <select v-model="nahvepardakht" class="form-control Pointer">
                      <option value="4014">واریز به حساب بانکی</option>
                      <option selected value="4015">واریز به حساب پس انداز</option>
                    </select>
                  </div>
                  <div
                    class="col-12 col-md-6 py-2 vam-f-account"
                    v-if="$session.get('CustCode') != 868 && $session.get('CustCode') != 8002"
                  >
                    <span v-if="nahvepardakht == 4015">
                      <label class="text-secondary">انتخاب حساب پس انداز </label>
                      <select class="form-control Pointer" v-model="NahveVarizDetail">
                        <option v-for="item in ListTaahodat" :key="item.id" :value="item.id">{{ item.desNoe }}</option>
                      </select>
                    </span>
                    <span v-if="nahvepardakht == 4014">
                      <label class="text-secondary">انتخاب حساب بانکی </label>
                      <select class="form-control Pointer" v-model="NahveVarizDetail">
                        <option v-for="item in ListAzaHesab" :key="item.id" :value="item.id">
                          {{ item.bankName }} -- {{ item.hesabNo }}
                        </option>
                      </select>
                    </span>
                  </div>
                </div>
              </section>
              <div class="request-vam-step-nav request-vam-step-nav--narrow">
                <button
                  type="button"
                  @click="prevPage(1)"
                  class="request-vam-step-nav__btn request-vam-step-nav__btn--prev"
                >
                  <i class="fa fa-arrow-right" aria-hidden="true"></i>
                  مرحله قبل
                </button>
                <button
                  type="button"
                  :disabled="vamDetail.Mablaghghest == 0 || vamDetail.MablaghVam == 0"
                  @click="nextPage(3)"
                  class="request-vam-step-nav__btn request-vam-step-nav__btn--next"
                >
                  مرحله بعد
                  <i class="fa fa-arrow-left" aria-hidden="true"></i>
                </button>
              </div>
            </div>

            <div v-if="divToShow == 3" class="request-vam-step-panel request-vam-step">
              <div class="vam-section">
                <div v-if="guarantorIndices.length === 0" class="vam-notice">
                  <i class="fas fa-info-circle" aria-hidden="true"></i>
                  <span>برای این نوع تسهیلات ضامنی نیاز نیست، بر روی دکمه مرحله بعد کلیک کنید.</span>
                </div>
                <div v-else class="request-vam-zamen-grid">
                  <div
                    v-for="index in guarantorIndices"
                    :key="index"
                    class="request-vam-zamen-slot"
                    :class="{ 'request-vam-zamen-slot--solo': isGuarantorSoloRow(index) }"
                  >
                    <label :for="'zamenCode' + index">{{ guarantorPlaceholder(index) }}</label>
                    <div class="request-vam-zamen-input-group">
                      <input
                        :id="'zamenCode' + index"
                        type="text"
                        inputmode="numeric"
                        maxlength="10"
                        class="form-control request-vam-zamen-code"
                        v-model="ListCodeMeli[index]"
                        placeholder="کد ملی ۱۰ رقمی"
                        dir="ltr"
                      />
                      <button
                        type="button"
                        class="request-vam-zamen-check-btn"
                        @click="GetZament(index)"
                      >
                        استعلام
                      </button>
                    </div>
                    <div v-if="ListZamen[index].NameFamily != ''" class="request-vam-zamen-result">
                      <i class="fas fa-user-check" aria-hidden="true"></i>
                      <span class="request-vam-zamen-result__label">نام ضامن:</span>
                      <span class="request-vam-zamen-result__name">{{ ListZamen[index].NameFamily }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <button
                class="d-none"
                id="ZamenModal"
                data-toggle="modal"
                data-target="#Modal-Orange"
              >
                modal
              </button>
              <div class="request-vam-step-nav request-vam-step-nav--narrow">
                <button
                  type="button"
                  @click="prevPage(2)"
                  class="request-vam-step-nav__btn request-vam-step-nav__btn--prev"
                >
                  <i class="fa fa-arrow-right" aria-hidden="true"></i>
                  مرحله قبل
                </button>
                <button
                  type="button"
                  :disabled="vamDetail.Mablaghghest == 0 || vamDetail.MablaghVam == 0"
                  @click="nextPage(4)"
                  class="request-vam-step-nav__btn request-vam-step-nav__btn--next"
                >
                  مرحله بعد
                  <i class="fa fa-arrow-left" aria-hidden="true"></i>
                </button>
              </div>
            </div>

            <div v-if="divToShow == 4" class="request-vam-step-panel request-vam-step">
              <div class="vam-section request-vam-upload-section">
                <div
                  v-if="$session.get('CustCode') != 868 && $cookies.isKey('DownloadForm')"
                  class="vam-notice vam-notice--warning"
                >
                  <i class="fas fa-file-download" aria-hidden="true"></i>
                  <span>
                    برای دانلود فرم درخواست وام
                    <a
                      class="vam-notice__link"
                      :href="$cookies.get('DownloadForm')"
                      download="فرم درخواست وام"
                      >اینجا</a
                    >
                    کلیک کنید.
                  </span>
                </div>

                <div v-if="$session.get('CustCode') != 868" class="request-vam-upload-card">
                  <input
                    type="file"
                    id="attachmentUploader"
                    @change="changeattach($event)"
                    class="d-none"
                    accept=".gif,.jpg,.jpeg,.png,.zip,.rar,.pdf"
                  />
                  <div class="request-vam-upload-card__icon" aria-hidden="true">
                    <i class="fas fa-cloud-upload-alt"></i>
                  </div>
                  <p class="request-vam-upload-card__title">بارگذاری مدارک درخواست وام</p>
                  <p class="request-vam-upload-card__hint">
                    فرمت‌های مجاز: gif, jpg, png, zip, rar, pdf — حداکثر ۵ مگابایت
                  </p>
                  <div v-if="attachment" class="request-vam-upload-card__meta">
                    <i class="far fa-file-alt" aria-hidden="true"></i>
                    <span class="request-vam-upload-card__file">{{ attachment.name }}</span>
                    <span class="request-vam-upload-card__size" dir="ltr">
                      {{ Math.round(attachment.size / 1000) }} KB
                    </span>
                  </div>
                  <button type="button" class="request-vam-upload-card__btn" @click="clickUploader">
                    {{ attachment ? 'تغییر فایل' : 'انتخاب فایل' }}
                  </button>
                </div>

                <div v-else class="request-vam-upload-grid">
                  <div
                    v-for="doc in UploadDocs868"
                    :key="doc.inputId"
                    class="request-vam-upload-card request-vam-upload-card--item"
                  >
                    <input
                      type="file"
                      class="d-none"
                      :id="doc.inputId"
                      accept=".gif,.jpg,.jpeg,.png,.zip,.rar,.pdf"
                      @change="UploadFile($event, doc.type, doc.inputId)"
                    />
                    <div class="request-vam-upload-card__icon" aria-hidden="true">
                      <i class="fas fa-file-import"></i>
                    </div>
                    <p class="request-vam-upload-card__title">{{ doc.title }}</p>
                    <div v-if="doc.file" class="request-vam-upload-card__meta">
                      <i class="far fa-file-alt" aria-hidden="true"></i>
                      <span class="request-vam-upload-card__file">{{ doc.file.name }}</span>
                    </div>
                    <button type="button" class="request-vam-upload-card__btn" @click="OpenUploader(doc.type)">
                      {{ doc.file ? 'تغییر فایل' : 'بارگذاری' }}
                    </button>
                  </div>
                </div>
              </div>
              <div class="request-vam-step-nav request-vam-step-nav--narrow">
                <button
                  type="button"
                  @click="prevPage(3)"
                  class="request-vam-step-nav__btn request-vam-step-nav__btn--prev"
                >
                  <i class="fa fa-arrow-right" aria-hidden="true"></i>
                  مرحله قبل
                </button>
                <button
                  type="button"
                  @click="nextPage(5)"
                  class="request-vam-step-nav__btn request-vam-step-nav__btn--next"
                >
                  مرحله بعد
                  <i class="fa fa-arrow-left" aria-hidden="true"></i>
                </button>
              </div>
            </div>

            <div v-if="divToShow == 5" class="request-vam-step-panel request-vam-step">
              <div class="vam-section request-vam-review">
                <p class="request-vam-review-intro">
                  اطلاعات زیر را بررسی کنید؛ در صورت نیاز با دکمه «ویرایش» به مرحله
                  مربوطه برگردید.
                </p>

                <section class="request-vam-review-hero">
                  <div class="request-vam-review-hero__top">
                    <span class="request-vam-review-hero__name">
                      <i class="fas fa-hand-holding-usd" aria-hidden="true"></i>
                      {{ SelectedVam.desNoe }}
                    </span>
                    <button type="button" class="request-vam-review-hero__edit" @click="goToStep(2)">
                      <i class="fas fa-pen" aria-hidden="true"></i>
                      ویرایش
                    </button>
                  </div>
                  <div class="request-vam-review-hero__amount">
                    <span dir="ltr">{{ $Comma3ragham(vamDetail.MablaghVam) }}</span>
                    <small>{{ $GetVahedPool() }}</small>
                  </div>
                  <span class="request-vam-review-hero__caption">مبلغ درخواستی</span>
                  <div class="request-vam-review-hero__stats">
                    <div v-if="$session.get('CustCode') != 9" class="request-vam-review-hero__stat">
                      <span class="request-vam-review-hero__stat-label">مبلغ هر قسط</span>
                      <span class="request-vam-review-hero__stat-value" dir="ltr">
                        {{ $Comma3ragham(vamDetail.Mablaghghest) }}
                        {{ $GetVahedPool() }}
                      </span>
                    </div>
                    <div class="request-vam-review-hero__stat">
                      <span class="request-vam-review-hero__stat-label">تعداد قسط</span>
                      <span class="request-vam-review-hero__stat-value" dir="ltr">{{ vamDetail.TedadGhest }}</span>
                    </div>
                    <div class="request-vam-review-hero__stat">
                      <span class="request-vam-review-hero__stat-label">تاریخ نیاز وام</span>
                      <span class="request-vam-review-hero__stat-value" dir="ltr">{{ vamDetail.NeedData }}</span>
                    </div>
                  </div>
                </section>

                <section class="request-vam-review-panel">
                  <header class="request-vam-review-panel__header">
                    <span class="request-vam-review-panel__icon" aria-hidden="true">
                      <i class="fas fa-user-friends"></i>
                    </span>
                    <h6 class="request-vam-review-panel__title">مشخصات ضامنین</h6>
                    <button
                      v-if="guarantorIndices.length > 0"
                      type="button"
                      class="request-vam-review-panel__edit"
                      @click="goToStep(3)"
                    >
                      <i class="fas fa-pen" aria-hidden="true"></i>
                      ویرایش
                    </button>
                  </header>
                  <div v-if="reviewGuarantors.length === 0" class="request-vam-review-empty">
                    ضامنی ثبت نشده است.
                  </div>
                  <div v-else class="request-vam-review-guarantor-list">
                    <article
                      v-for="(item, key) in reviewGuarantors"
                      :key="item.Id || item.CodeMeli || key"
                      class="request-vam-review-guarantor-card"
                    >
                      <header class="request-vam-review-guarantor-card__header">
                        <span class="request-vam-review-guarantor-card__badge">{{ key + 1 }}</span>
                        <span class="request-vam-review-guarantor-card__title">{{ item.NameFamily }}</span>
                      </header>
                      <div class="request-vam-review-guarantor-card__grid">
                        <div class="request-vam-review-field">
                          <span class="request-vam-review-field__label">کدملی</span>
                          <span class="request-vam-review-field__value request-vam-review-field__value--ltr">{{ item.CodeMeli }}</span>
                        </div>
                        <div class="request-vam-review-field">
                          <span class="request-vam-review-field__label">نام پدر</span>
                          <span class="request-vam-review-field__value">{{ item.Pedar }}</span>
                        </div>
                        <div class="request-vam-review-field">
                          <span class="request-vam-review-field__label">شماره تماس</span>
                          <span class="request-vam-review-field__value request-vam-review-field__value--ltr">{{ item.Tel }}</span>
                        </div>
                        <div class="request-vam-review-field">
                          <span class="request-vam-review-field__label">شماره همراه</span>
                          <span class="request-vam-review-field__value request-vam-review-field__value--ltr">{{ item.Mobile }}</span>
                        </div>
                        <div class="request-vam-review-field request-vam-review-field--full">
                          <span class="request-vam-review-field__label">آدرس</span>
                          <span class="request-vam-review-field__value">{{ item.Adres }}</span>
                        </div>
                      </div>
                    </article>
                  </div>
                </section>

                <section class="request-vam-review-panel">
                  <header class="request-vam-review-panel__header">
                    <span class="request-vam-review-panel__icon" aria-hidden="true">
                      <i class="fas fa-paperclip"></i>
                    </span>
                    <h6 class="request-vam-review-panel__title">مشخصات فایل‌ها</h6>
                    <button type="button" class="request-vam-review-panel__edit" @click="goToStep(4)">
                      <i class="fas fa-pen" aria-hidden="true"></i>
                      ویرایش
                    </button>
                  </header>
                  <template v-if="$session.get('CustCode') == 868">
                    <template v-for="doc in UploadDocs868">
                      <div v-if="doc.file" :key="doc.inputId" class="request-vam-review-file">
                        <i class="far fa-file-alt" aria-hidden="true"></i>
                        <span class="request-vam-review-file__name">{{ doc.title }}: {{ doc.file.name }}</span>
                        <span class="request-vam-review-file__size" dir="ltr">
                          {{ Math.round(doc.file.size / 1000) }} KB
                        </span>
                      </div>
                      <div
                        v-else
                        :key="doc.inputId"
                        class="request-vam-review-empty request-vam-review-empty--danger"
                      >
                        <i class="fas fa-exclamation-circle" aria-hidden="true"></i>
                        فایل {{ doc.title }} بارگذاری نشده
                      </div>
                    </template>
                  </template>
                  <div v-else-if="!attachment" class="request-vam-review-empty request-vam-review-empty--danger">
                    <i class="fas fa-exclamation-circle" aria-hidden="true"></i>
                    فایلی بارگذاری نشده
                  </div>
                  <div v-else class="request-vam-review-file">
                    <i class="far fa-file-alt" aria-hidden="true"></i>
                    <span class="request-vam-review-file__name">{{ attachment.name }}</span>
                    <span class="request-vam-review-file__size" dir="ltr">
                      {{ Math.round(attachment.size / 1000) }} KB
                    </span>
                  </div>
                </section>
              </div>

              <div class="request-vam-step-nav request-vam-step-nav--narrow">
                <button
                  type="button"
                  @click="prevPage(4)"
                  class="request-vam-step-nav__btn request-vam-step-nav__btn--prev"
                >
                  <i class="fa fa-arrow-right" aria-hidden="true"></i>
                  مرحله قبل
                </button>
                <button
                  type="button"
                  @click="FinalSubmit"
                  class="request-vam-step-nav__btn request-vam-step-nav__btn--submit"
                >
                  <i class="fa fa-check" aria-hidden="true"></i>
                  ثبت نهایی درخواست
                </button>
              </div>
            </div>
          </div>
        </template>
      </template>
    </net-pa-card>

    <modal-custom>
      <template v-slot:ContentModalOrange>
        <div class="container-fluid">
          <div class="alert alert-info text-center">
            اطلاعات ضامن خود را وارد نمایید و اطلاعات خواسته شده را تکمیل فرمایید .
          </div>
          <div class="row">
            <div class="col-12 col-md-6 p-2">
              <input type="text" placeholder="نام و نام خانوادگی" class="form-control"
                v-model="ZamenToInsert.NameFamily" />
            </div>
            <div class="col-12 col-md-6 p-2">
              <input type="text" placeholder="نام پدر" class="form-control" v-model="ZamenToInsert.Pedar" />
            </div>
            <div class="col-12 col-md-6 p-2">
              <input type="text" placeholder="شغل" class="form-control" v-model="ZamenToInsert.Job" />
            </div>
            <div class="col-12 col-md-6 p-2">
              <input type="number" placeholder="تلفن ثابت" class="form-control text-left" v-model="ZamenToInsert.Tel" />
            </div>
            <div class="col-12 col-md-6 p-2">
              <input type="number" placeholder="تلفن همراه" class="form-control text-left"
                v-model="ZamenToInsert.Mobile" />
            </div>
            <div class="col-12 p-2 col-md-12">
              <textarea class="form-control" placeholder="آدرس" v-model="ZamenToInsert.Adres"></textarea>
            </div>
            <div class="col-md-4"></div>
            <div class="col-md-4">
              <button class="btn btn-success NetPa-btn w-100" data-dismiss="modal">ثبت ضامن</button>
            </div>
            <div class="col-md-4"></div>
          </div>
        </div>
      </template>
    </modal-custom>
  </div>
</template>
<script>
import NetPaCard from '../Tools/NetPa/NetPaCard.vue'
import Panel from '../Tools/NetPa/Panel.vue'
import ModalCustom from '../Tools/ModalCustom.vue'

export default {
  components: { NetPaCard, Panel, ModalCustom },

  data() {
    return {
      isAcceptSharaytVam: false,
      showGhavaninVam: false,
      stepperCompact: false,
      stepperResizeObserver: null,
      TblNoeId: null,
      NahveVarizDetail: null,
      AtachVam: false,
      nahvepardakht: 4015,
      DataAxiosTaahodat: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'ListTaahodat',
        Token: this.$session.get('TokenNetPa'),
      },
      DataAxiosAzaHesab: {
        ArryfildValue: '',
        Method: 'Get',
        Action: 'AzaHesab',
        Token: this.$session.get('TokenNetPa'),
      },
      ListTaahodat: [],
      ListAzaHesab: [],
      DataAxiosGetNoeVam: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'RequestVam',
        Token: this.$session.get('TokenNetPa'),
      },
      DataActionVamCondition: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'VamCondition',
        Token: this.$session.get('TokenNetPa'),
      },
      DataActionNoePolicy: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'NoePolicy',
        Token: this.$session.get('TokenNetPa'),
      },
      Vamha: [],
      divToShow: 1,
      maxReachedStep: 1,
      completedSteps: [],
      SelectedVam: {},
      vamDetail: {
        Mablaghghest: 0,
        TedadGhest: 24,
        MablaghVam: 0,
        NeedData: '',
      },
      ListZamen: [
        {
          Adres: '',
          Mobile: '',
          Tel: '',
          Pedar: '',
          CodeMeli: '',
          NameFamily: '',
          Job: '',
          Id: null,
        },
        {
          Adres: '',
          Mobile: '',
          Tel: '',
          Pedar: '',
          CodeMeli: '',
          NameFamily: '',
          Job: '',
          Id: null,
        },
        {
          Adres: '',
          Mobile: '',
          Tel: '',
          Pedar: '',
          CodeMeli: '',
          NameFamily: '',
          Job: '',
          Id: null,
        },
      ],
      ZamenToInsert: {},
      ListCodeMeli: ['', '', ''],
      attachment: null,
      FileHokm868: null,
      FileZamenanat868: null,
      FileGhardad868: null,
      needVamId: 0,
      requiredZamenCount: 3,
    }
  },
  computed: {
    vamSteps() {
      return [
        { id: 1, label: 'انتخاب نوع وام' },
        { id: 2, label: 'اطلاعات تکمیلی' },
        { id: 3, label: 'مشخصات ضامنین' },
        { id: 4, label: 'آپلود مدارک' },
        { id: 5, label: 'تایید نهایی' },
      ]
    },
    guarantorIndices() {
      const count = Math.max(
        0,
        Math.min(3, Number(this.requiredZamenCount) || 3),
      )
      return Array.from({ length: count }, (_, index) => index)
    },
    reviewGuarantors() {
      return (this.ListZamen || []).filter(
        (item) => item && item.Id != null,
      )
    },
    UploadDocs868() {
      return [
        { type: 1, inputId: 'FileHokm', title: 'حکم کارگزینی وام‌گیرنده و ضامن', file: this.FileHokm868 },
        { type: 2, inputId: 'FileZemanat', title: 'فرم ضمانت', file: this.FileZamenanat868 },
        { type: 3, inputId: 'FileGhrardad', title: 'قرارداد وام', file: this.FileGhardad868 },
      ]
    },
  },
  watch: {
    showGhavaninVam(value) {
      if (!value) this.$nextTick(this.initStepperObserver)
    },
  },
  mounted() {
    this.vamDetail.NeedData = this.$GetJalaliDate()
    this.GetNoeVam()

    if (this.$session.get('CustCode') == 643) {
      this.showGhavaninVam = true
    }

    window.addEventListener('resize', this.updateStepperCompact)
    this.$nextTick(this.initStepperObserver)
  },
  beforeDestroy() {
    if (this.stepperResizeObserver) this.stepperResizeObserver.disconnect()
    window.removeEventListener('resize', this.updateStepperCompact)
  },
  methods: {
    initStepperObserver() {
      this.updateStepperCompact()
      if (this.stepperResizeObserver || typeof ResizeObserver === 'undefined' || !this.$refs.vamStepper) return
      this.stepperResizeObserver = new ResizeObserver(this.updateStepperCompact)
      this.stepperResizeObserver.observe(this.$refs.vamStepper)
    },
    updateStepperCompact() {
      const el = this.$refs.vamStepper
      if (!el) return
      this.stepperCompact = el.clientWidth < 640
    },

    GetNoeVam() {
      var formdata = new FormData()
      formdata.append('wwwtblAzaId', this.$session.get('UserInfoNetPa').wwwtblAzaId)
      this.DataAxiosGetNoeVam.ArryfildValue = formdata
      this.$PostFormData(this.DataAxiosGetNoeVam).then((data) => {
        this.Vamha = data
      })
    },
    selectCurent(data, number) {
      this.activateStep(number)
    },
    isGuarantorSoloRow(index) {
      const total = this.guarantorIndices.length
      return total === 1 || (total % 2 === 1 && index === total - 1)
    },
    guarantorPlaceholder(index) {
      const labels = ['اول', 'دوم', 'سوم']
      return `کدملی ضامن ${labels[index] || index + 1}`
    },
    resolveRequiredZamenCount(result, data) {
      const policyCount =
        result && result.tedad != null && result.tedad !== ''
          ? Number(result.tedad)
          : null
      const vamCount =
        data && data.tedadZamen != null && data.tedadZamen !== ''
          ? Number(data.tedadZamen)
          : null
      const resolved = policyCount ?? vamCount ?? 3
      if (Number.isNaN(resolved)) return 3
      return Math.max(0, Math.min(3, resolved))
    },
    getVamAmount(value) {
      if (value == null || value === '') return 0
      return Number(String(value).replaceAll(/,/g, '').replace(/\./g, '')) || 0
    },
    isStepCompleted(step) {
      return this.completedSteps.includes(step)
    },
    isStepUnlocked(step) {
      if (step === 1) return true
      if (step === 2) return Object.entries(this.SelectedVam).length !== 0
      if (step === 3) {
        return (
          this.getVamAmount(this.vamDetail.Mablaghghest) !== 0 &&
          this.getVamAmount(this.vamDetail.MablaghVam) !== 0
        )
      }
      return true
    },
    canNavigateToStep(step) {
      if (step > this.maxReachedStep) return false
      return this.isStepUnlocked(step)
    },
    getStepTabTitle(step) {
      if (this.canNavigateToStep(step)) return ''
      if (step === 2 && Object.entries(this.SelectedVam).length === 0) {
        return 'ابتدا نوع وام را مشخص کنید'
      }
      if (
        step === 3 &&
        (this.getVamAmount(this.vamDetail.Mablaghghest) === 0 ||
          this.getVamAmount(this.vamDetail.MablaghVam) === 0)
      ) {
        return 'لطفا اطلاعات وام را تکمیل کنید'
      }
      if (step > this.maxReachedStep) {
        return 'ابتدا مراحل قبلی را تکمیل کنید'
      }
      return ''
    },
    goToStep(step) {
      if (!this.canNavigateToStep(step)) return
      window.scrollTo({ top: 0 })
      this.divToShow = step
    },
    prevPage(step) {
      if (step < 1 || step > 5) return
      this.goToStep(step)
    },
    activateStep(number) {
      for (let i = 1; i < number; i++) {
        if (!this.completedSteps.includes(i)) {
          this.completedSteps.push(i)
        }
      }
      this.maxReachedStep = Math.max(this.maxReachedStep, number)
      this.divToShow = number
      window.scrollTo({ top: 0 })
    },
    seLectVam(data) {     
      var formdata = new FormData()
      formdata.append('wwwtblAzaId', this.$session.get('UserInfoNetPa').wwwtblAzaId)
      formdata.append('wwwtblNoeId', data.id)
      this.TblNoeId = data.id
      this.DataActionVamCondition.ArryfildValue = formdata
      this.DataActionNoePolicy.ArryfildValue = formdata
      this.$PostFormData(this.DataActionVamCondition).then((res) => {
        this.$store.state.loading = true
        switch (res.id) {
          case 0:
            this.$PostFormData(this.DataActionNoePolicy).then((result) => {
              if (result.result == 'SUCCESS') {
                this.SelectedVam = data
                this.requiredZamenCount = this.resolveRequiredZamenCount(result, data)
                this.vamDetail.MablaghVam = this.$Comma3ragham(data.mablaghVam)
                if (this.$session.get('CustCode') == 868 && data.tedadGhestVam == 0) {
                  this.vamDetail.TedadGhest = 24
                } else {
                  this.vamDetail.TedadGhest = data.tedadGhestVam
                }
                this.vamDetail.Mablaghghest = data.mablaghVam > 0 ? Math.floor(Number(data.mablaghVam) / Number(data.tedadGhestVam)) : 0
              } else {
                this.$mySweetDefault('هشدار', result.result, 'warning', 2000)
              }
            })
            break
          case 1:
            this.$mySweetDefault('هشدار', 'سابقه عضویت شما جهت درخواست وام کافی نمیباشد.', 'warning', 2000)
            break
          case 2:
            this.$mySweetDefault('هشدار', 'تعداد تسهیلات دریافتی شما بیش از حد مجاز میباشد.', 'warning', 2000)
            break
          case 3:
            this.$mySweetDefault('هشدار', 'سقف بودجه ماهیانه به اتمام رسیده است.', 'warning', 2000)
            break

          case 5:
            this.$mySweetDefault('هشدار', 'موجودی حساب شما جهت درخواست تسهیلات کمتر از سقف تایید شده میباشد.', 'warning', 2000)
            break
          case 6:
            this.$mySweetDefault('هشدار', 'دریافت این نوع تسهیلات برای حوزه و یا نوع عضویت شما فعال نمیباشد.', 'warning', 2000)
            break
          case 7:
            this.$mySweetDefault('هشدار', 'به علت بدهی قبلی از این نوع تسهیلات شما مجاز به ثبت درخواست نمیباشید.', 'warning', 2000)
            break
          case 8:
            this.$mySweetDefault('هشدار', 'این تسهیلات پیش از این توسط شما درخواست داده شده است.', 'warning', 2000)
            break
          default:
            this.$mySweetDefault('خطا', 'پاسخی از سرور دریافت نشد.', 'error', 2000)
        }
        this.$store.state.loading = false
      })
    },
    nextPage(number) {
      // console.log("@@", number);
      if (number == 2) {
        const formData = new FormData()
        formData.append('wwwtblAzaId', this.$session.get('UserInfoNetPa').wwwtblAzaId)
        formData.append('wwwtblSarfaslTypeId', 2)
        this.DataAxiosTaahodat.ArryfildValue = formData
        this.$PostFormData(this.DataAxiosTaahodat).then((data) => {
          this.ListTaahodat = data
        })

        this.DataAxiosAzaHesab.ArryfildValue = { Id: this.$session.get('UserInfoNetPa').wwwtblAzaId }
        this.$GetData_Header(this.DataAxiosAzaHesab).then((data) => {
          this.ListAzaHesab = data
        })
      }

      if (number == 3 && (this.vamDetail.Mablaghghest == 0 || this.vamDetail.MablaghVam == 0)) {
        this.$mySweetDefault('هشدار', 'مبلغ وام و یا قسط آن نمیتواند صفر باشد.', 'warning', 2000)
      } else if (number == 3 && this.vamDetail.TedadGhest == 0) {
        this.$mySweetDefault('هشدار', 'تعداد قسط نمیتواند خالی باشد', 'warning', 2000)
      } else if (number == 3) {
        if (this.$session.get('CustCode') == 9) {
          this.cusCode9_VamRules()
        } else {
          this.activateStep(number)
        }
      } else {
        this.activateStep(number)
      }
    },
    calculateMablaghghest(e) {
      // this.vamDetail.TedadGhest = this.vamDetail.TedadGhest == 0 ? 1 : this.vamDetail.TedadGhest
      if (this.$session.get('CustCode') == 868) {
        var formdata = new FormData()
        formdata.append('wwwtblNoeId', this.SelectedVam.id)
        formdata.append('MabDarkhastVam', Number(this.vamDetail.MablaghVam.replace(/,/g, '')))
        formdata.append('TedadGhest', this.vamDetail.TedadGhest)
        formdata.append('TarixDarkhast', this.vamDetail.NeedData)
        var DataAxios = {
          ArryfildValue: formdata,
          Method: 'Post',
          Action: 'InsNewVam/CalcKarmozd',
          Token: this.$session.get('TokenNetPa'),
        }
        this.$PostFormData(DataAxios).then((res) => {
          this.vamDetail.Mablaghghest = (res.data[0].karmozdBimeSood + Number(this.vamDetail.MablaghVam.replace(/,/g, ''))) / this.vamDetail.TedadGhest
          this.vamDetail.Mablaghghest = Math.round(this.vamDetail.Mablaghghest)
          this.vamDetail.Mablaghghest = this.vamDetail.Mablaghghest + ''
          this.vamDetail.Mablaghghest = Number(this.vamDetail.Mablaghghest.replace(/\d{4}$/, '0000'))
        })
      } else {
        if (this.vamDetail.TedadGhest == 0) {
          this.vamDetail.Mablaghghest = 0
        } else {
          this.vamDetail.Mablaghghest = Number(this.vamDetail.MablaghVam.replaceAll(/,/g, '')) > 0 ? Number(this.vamDetail.MablaghVam.replaceAll(/,/g, '')) / this.vamDetail.TedadGhest : 0
        }
      }
    },

    cusCode9_VamRules() {
      let request = {
        Amount: this.vamDetail.MablaghVam.replaceAll(',', ''),
        NoeId: this.TblNoeId,
        TedadGhest: this.vamDetail.TedadGhest,
      }
      this.$PostData_new('VamCondition/CusCode9_VamRules', 'post', request).then((res) => {
        if (res.isSuccess == true) {
          this.activateStep(3)
        } else {
          if (res.data != null) {
            let maxVam = this.$Comma3ragham(res.data)
            let messge = res.message + maxVam + ' است'
            this.$mySweetDefault('هشدار', messge, 'warning')
          } else {
            this.$mySweetDefault('هشدار', res.message, 'warning')
          }
          return
        }
      })
    },
    GetZament(number) {
      if (this.$session.get('UserInfoNetPa').codeMeli.trim() == this.ListCodeMeli[number]) {
        this.$mySweetDefault('خطا', 'شما کد ملی خود را وارد کرده اید', 'error', 2000)
        return
      }

      if (number == 0) {
        if (this.ListCodeMeli[1] == this.ListCodeMeli[0]) {
          this.ListCodeMeli[0] = ''
          this.$mySweetDefault('هشدار', 'ضامن تکراری است', 'warning', 2000)
          this.ListZamen[number].Tel = ''
          this.ListZamen[number].Pedar = ''
          this.ListZamen[number].NameFamily = ''
          this.ListZamen[number].Mobile = ''
          this.ListZamen[number].Adres = ''
          this.ListZamen[number].Id = null
          this.ListZamen[number].CodeMeli = ''
          return
        }
        if (this.ListCodeMeli[2] == this.ListCodeMeli[0]) {
          this.ListCodeMeli[0] = ''
          this.ListZamen[number].Tel = ''
          this.ListZamen[number].Pedar = ''
          this.ListZamen[number].NameFamily = ''
          this.ListZamen[number].Mobile = ''
          this.ListZamen[number].Adres = ''
          this.ListZamen[number].Id = null
          this.ListZamen[number].CodeMeli = ''
          this.$mySweetDefault('هشدار', 'ضامن تکراری است', 'warning', 2000)
          return
        }
      }
      if (number == 1) {
        if (this.ListCodeMeli[0] == this.ListCodeMeli[1]) {
          this.ListCodeMeli[1] = ''
          this.$mySweetDefault('هشدار', 'ضامن تکراری است', 'warning', 2000)
          this.ListZamen[number].Tel = ''
          this.ListZamen[number].Pedar = ''
          this.ListZamen[number].NameFamily = ''
          this.ListZamen[number].Mobile = ''
          this.ListZamen[number].Adres = ''
          this.ListZamen[number].Id = null
          this.ListZamen[number].CodeMeli = ''
          return
        }
        if (this.ListCodeMeli[2] == this.ListCodeMeli[1]) {
          this.ListCodeMeli[1] = ''
          this.$mySweetDefault('هشدار', 'ضامن تکراری است', 'warning', 2000)

          this.ListZamen[number].Tel = ''
          this.ListZamen[number].Pedar = ''
          this.ListZamen[number].NameFamily = ''
          this.ListZamen[number].Mobile = ''
          this.ListZamen[number].Adres = ''
          this.ListZamen[number].Id = null
          this.ListZamen[number].CodeMeli = ''
          return
        }
      }
      if (number == 2) {
        if (this.ListCodeMeli[0] == this.ListCodeMeli[2]) {
          this.ListCodeMeli[2] = ''
          this.$mySweetDefault('هشدار', 'ضامن تکراری است', 'warning', 2000)
          this.ListZamen[number].Tel = ''
          this.ListZamen[number].Pedar = ''
          this.ListZamen[number].NameFamily = ''
          this.ListZamen[number].Mobile = ''
          this.ListZamen[number].Adres = ''
          this.ListZamen[number].Id = null
          this.ListZamen[number].CodeMeli = ''
          return
        }
        if (this.ListCodeMeli[1] == this.ListCodeMeli[2]) {
          this.ListCodeMeli[2] = ''
          this.$mySweetDefault('هشدار', 'ضامن تکراری است', 'warning', 2000)
          this.ListZamen[number].Tel = ''
          this.ListZamen[number].Pedar = ''
          this.ListZamen[number].NameFamily = ''
          this.ListZamen[number].Mobile = ''
          this.ListZamen[number].Adres = ''
          this.ListZamen[number].Id = null
          this.ListZamen[number].CodeMeli = ''
          return
        }
      }

      if (this.ListCodeMeli[number].length < 10) {
        this.$mySweetDefault('خطا', ' طول کد ملی نمیتواند کمتر از 10 رقم باشد', 'error', 2000)
      } else {
        var DataAxiosGetZament = {
          ArryfildValue: '',
          Method: 'Post',
          Action: 'GetZamenByMelli2',
          Token: this.$session.get('TokenNetPa'),
        }
        var formdata = new FormData()
        formdata.append('wwwtblShobeId', this.$session.get('UserInfoNetPa').wwwtblShobeId)
        formdata.append('CodeMeli', this.ListCodeMeli[number])
        DataAxiosGetZament.ArryfildValue = formdata
        this.$PostFormData(DataAxiosGetZament).then((data) => {
          if (data != null) {
            if (data.success && data.success == 'Fail') {
              this.$mySweetDefault('خطا', data.message, 'error', 3500)
            } else if (data.mandeZemanat != null) {
              if (data.mandeZemanat >= Number(this.vamDetail.MablaghVam.replace(/\,/g, ''))) {
                //مبلغ وام کمتر از سقف ضمانت می باشد
                this.ListZamen[number].Tel = data.tel
                this.ListZamen[number].Pedar = data.pedar
                this.ListZamen[number].NameFamily = data.nameFamily
                this.ListZamen[number].Mobile = data.mobile
                this.ListZamen[number].Adres = data.adres
                this.ListZamen[number].Id = data.id
                this.ListZamen[number].CodeMeli = this.ListCodeMeli[number]
              } else {
                this.$mySweetDefault('خطا', 'ضامن وارد شده به سقف ضمانت خود رسیده ، لطفا ضامن دیگری انتخاب نمایید', 'error', 3500)
              }
            } else {
              this.ListZamen[number].Tel = data.tel
              this.ListZamen[number].Pedar = data.pedar
              this.ListZamen[number].NameFamily = data.nameFamily
              this.ListZamen[number].Mobile = data.mobile
              this.ListZamen[number].Adres = data.adres
              this.ListZamen[number].Id = data.id
              this.ListZamen[number].CodeMeli = this.ListCodeMeli[number]
            }
          } else {
            this.ZamenToInsert = this.ListZamen[number]
            this.$mySweetDefault('هشدار', 'فرد مورد نظر در بین مشتریان ' + this.$session.get('IsTaavoniEtebar') == true ? 'تعاونی اعتبار' : 'صندوق' + ' یافت نشد. مشخصات ضامن را به صورت دستی وارد کنید.', 'warning', 3500)
            document.getElementById('ZamenModal').click()
          }
        })
      }
    },
    clickUploader() {
      document.getElementById('attachmentUploader').click()
    },
    changeattach(e) {
     const file = e.target.files[0]
    if (!file) return

    const allowedExtensions = ['gif', 'jpg', 'jpeg', 'png', 'zip', 'rar', 'pdf']
    const fileExtension = file.name.split('.').pop().toLowerCase()
    if (!allowedExtensions.includes(fileExtension)) {
      this.$mySweetDefaultTost(
        'فرمت فایل مجاز نیست',
        `فرمت ${fileExtension} پشتیبانی نمی‌شود.`,
        'error',
        3000
      )
      e.target.value = ''
      return
    }
      this.attachment = document.getElementById('attachmentUploader').files[0]
      if (this.attachment.size / 1000000 > 5) {
        this.$mySweetDefaultTost('هشدار', 'حجم فایل نمیتواند بیش از 5 مگابایت باشد', 'error', 2000)
        document.getElementById('attachmentUploader').value = null
        this.attachment = null
      }
    },
    FinalSubmit() {
      var formdata = new FormData()

      if (this.ListCodeMeli[0] == null) {
        this.$mySweetDefault('عملیات ناموفق', 'وارد کردن ضامن اول اجباری میباشد', 'error', 2500)
        return
      }

      this.vamDetail.MablaghVam = this.vamDetail.MablaghVam.replaceAll(',', '')

      formdata.append('NahveVarizDetail', this.NahveVarizDetail)
      formdata.append('WwwtblcomboIdNahveVarizGrp7', this.nahvepardakht)
      formdata.append('wwwtblAzaId', this.$session.get('UserInfoNetPa').wwwtblAzaId)
      formdata.append('RequestTarix', this.$store.state.JalaliDate)
      formdata.append('Mablagh', this.vamDetail.MablaghVam)
      formdata.append('MablaghTavanaiePardakht', this.vamDetail.MablaghVam)
      formdata.append('TedadGhest', this.vamDetail.TedadGhest)
      formdata.append('NeedTarix', this.vamDetail.NeedData)
      formdata.append('CodeMeliZamenAsli', this.ListCodeMeli[0])
      formdata.append('CodeMeliZamenFarei', this.ListCodeMeli[1])
      formdata.append('NameFamilyZamenAsli', this.ListZamen[0].NameFamily == null ? '' : this.ListZamen[0].NameFamily)
      formdata.append('CodeMeliMoaref', this.ListCodeMeli[2])
      formdata.append('PedarZamenAsli', this.ListZamen[0].Pedar == null ? '' : this.ListZamen[0].Pedar)
      formdata.append('TelZamenAsli', this.ListZamen[0].Tel == null ? '' : this.ListZamen[0].Tel)
      formdata.append('MobileZamenAsli', this.ListZamen[0].Mobile == null ? '' : this.ListZamen[0].Mobile)
      formdata.append('AdresZamenAsli', this.ListZamen[0].Adres == null ? '' : this.ListZamen[0].Adres)
      formdata.append('MobileZamenFarei', this.ListZamen[1].Mobile == null ? '' : this.ListZamen[1].Mobile)
      formdata.append('AdresZamenFarei', this.ListZamen[1].Adres == null ? '' : this.ListZamen[1].Adres)
      formdata.append('TelZamenFarei', this.ListZamen[1].Tel == null ? '' : this.ListZamen[1].Tel)
      formdata.append('PedarZamenFarei', this.ListZamen[1].Pedar == null ? '' : this.ListZamen[1].Pedar)
      formdata.append('NameFamilyZamenFarei', this.ListZamen[1].NameFamily == null ? '' : this.ListZamen[1].NameFamily)
      formdata.append('ShoghlZamenAsli', this.ListZamen[0].Job == null ? '' : this.ListZamen[0].Job)
      formdata.append('ShoghlZamenFarei', this.ListZamen[1].Job == null ? '' : this.ListZamen[1].Job)
      formdata.append('ShoglMoaref', this.ListZamen[2].Job == null ? '' : this.ListZamen[2].Job)
      formdata.append('AdresMoaref', this.ListZamen[2].Adres == null ? '' : this.ListZamen[2].Adres)
      formdata.append('MobileMoaref', this.ListZamen[2].Mobile == null ? '' : this.ListZamen[2].Mobile)
      formdata.append('TellMoaref', this.ListZamen[2].Tel == null ? '' : this.ListZamen[2].Tel)
      formdata.append('PedarMoaref', this.ListZamen[2].Pedar == null ? '' : this.ListZamen[2].Pedar)
      formdata.append('NameFamiliMoaref', this.ListZamen[2].NameFamily == null ? '' : this.ListZamen[2].NameFamily)
      formdata.append('AzaIdMoaref', this.ListZamen[2].Id == null ? '' : this.ListZamen[2].Id)
      formdata.append('AzaIdZamenFarei', this.ListZamen[1].Id == null ? '' : this.ListZamen[2].Id)
      formdata.append('AzaIdZamen', this.ListZamen[0].Id == null ? '' : this.ListZamen[0].Id)
      formdata.append('IsTaeidVam', 0)
      formdata.append('wwwtblNoeId', this.SelectedVam.id)
      if (this.$session.get('CustCode') == 868) {
        if (this.FileHokm868) formdata.append('FileHokm868', this.FileHokm868)
        if (this.FileZamenanat868) formdata.append('FileZamenanat868', this.FileZamenanat868)
        if (this.FileGhardad868) formdata.append('FileGhardad868', this.FileGhardad868)
      } else if (this.attachment) {
        formdata.append('file', this.attachment)
      }
      var DataAxiosSubmit = {
        ArryfildValue: formdata,
        Method: 'Post',
        Action: 'InsNewVam',
        Token: this.$session.get('TokenNetPa'),
      }

      this.$PostFormData(DataAxiosSubmit)
        .then((data) => {
          if (data.success == 'SUCCESS') {
            const fileErrorMsg = 'درخواست وام ثبت نشد. خطا در ذخیره فایل.'
            const cancelIncomplete = (id) => {
              if (!id) return
              var formCancel = new FormData()
              formCancel.append('needVamId', id)
              this.$PostFormData({
                ArryfildValue: formCancel,
                Method: 'Post',
                Action: 'InsNewVam/CancelIncompleteNeedVam',
                Token: this.$session.get('TokenNetPa'),
              }).then(() => {})
            }
            const showFileError = (needIdToCancel) => {
              if (needIdToCancel) cancelIncomplete(needIdToCancel)
              this.needVamId = 0
              this.$mySweetDefault('عملیات ناموفق', fileErrorMsg, 'error', 2500)
            }
            const finishSuccess = () => {
              this.$mySweetDefault(
                'عملیات موفق',
                'درخواست وام شما با کد رهگیری ' + data.codeRahgiri + ' در سیستم ثبت شد.',
                'success',
                2500
              )
              this.$router.push('loanFollowup')
            }

            if (data.fileSaved === false) {
              showFileError()
              return
            }

            this.needVamId = data.needVamId
            finishSuccess()
          } else {
            this.needVamId = 0
            this.$mySweetDefault(
              'عملیات ناموفق',
              data.msg ? data.msg : 'درخواست شما در سیستم ثبت نشد.',
              'warning',
              2500
            )
          }
        })
        .catch((error) => {
          this.$mySweetDefault('عملیات ناموفق', 'مشکلی بوجود آمده است. دوباره تلاش کنید', 'error', 2500)
          this.needVamId = 0
          console.warn(error)
        })
    },
    CheckupSaghfVam(e) {
      if (e.target.value.replace(/,/g, '') > this.SelectedVam.mabTaeenSaghfVam) {
        this.vamDetail.MablaghVam = this.$Comma3ragham(this.SelectedVam.mabTaeenSaghfVam)
        this.calculateMablaghghest()
        this.$mySweetDefault('خطا در مبلغ تسهیلات', ' سقف مبلغ تسهیلات ' + this.$Comma3ragham(this.SelectedVam.mabTaeenSaghfVam) + ' می باشد و نمی توانید بیشتر از این مبلغ درخواست تسهیلات کنید ', 'error', 3000)
      }
    },
    OpenUploader(Type) {
      // Type 1= ExcelFile, Type 2=JsonFile
      if (Type == 1) {
        document.getElementById('FileHokm').click()
      }
      if (Type == 2) {
        document.getElementById('FileZemanat').click()
      }
      if (Type == 3) {
        document.getElementById('FileGhrardad').click()
      }
    },
    UploadFile(e, Type, FileUploaderId) {
      const file = e.target.files[0]
    if (!file) return

    const allowedExtensions = ['gif', 'jpg', 'jpeg', 'png', 'zip', 'rar', 'pdf']
    const fileExtension = file.name.split('.').pop().toLowerCase()
    if (!allowedExtensions.includes(fileExtension)) {
      this.$mySweetDefaultTost(
        'فرمت فایل مجاز نیست',
        `فرمت ${fileExtension} پشتیبانی نمی‌شود.`,
        'error',
        3000
      )
      e.target.value = ''
      return
    }
      if (e.srcElement.files[0].size / 1000000 > 3) {
        this.$mySweetDefaultTost('هشدار', 'حجم فایل نمیتواند بیش از 3 مگابایت باشد', 'error', 2000)
        document.getElementById(FileUploaderId).value = null
      } else {
        if (Type == 1) {
          this.FileHokm868 = e.srcElement.files[0]
        }
        if (Type == 2) {
          this.FileZamenanat868 = e.srcElement.files[0]
        }
        if (Type == 3) {
          this.FileGhardad868 = e.srcElement.files[0]
        }
      }
    },
  },
  updated() {
    this.vamDetail.Mablaghghest = Math.floor(this.vamDetail.Mablaghghest)
    this.$PutCommatoInput()
    // this.vamDetail.Mablaghghest ==this.$Comma3ragham(this.vamDetail.Mablaghghest);
  },
}
</script>
<style scoped>
.request-vam-content {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  max-width: 100%;
  margin: 0;
  padding: 0;
}

.request-vam-step-panel {
  flex: 1 1 100%;
  align-self: stretch;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
}

.request-vam-step {
  padding: 0.75rem 0;
}

.request-vam-form-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 0.5rem 0.75rem;
  width: 100%;
  margin: 0;
  padding: 0;
}

.request-vam-form-grid > [class*="col-"] {
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  flex: none;
  padding-left: 0 !important;
  padding-right: 0 !important;
}

@media (min-width: 768px) {
  .request-vam-form-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .request-vam-form-grid > .col-md-6 {
    flex: none;
    max-width: 100%;
    width: 100%;
  }
}

.request-vam-date-field ::v-deep .vpd-main {
  display: block;
  width: 100%;
}

.request-vam-date-field ::v-deep .vpd-input-group {
  display: flex;
  align-items: stretch;
  width: 100%;
  min-height: calc(1.5em + 0.75rem + 2px);
  height: calc(1.5em + 0.75rem + 2px);
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  background: #fff;
  overflow: hidden;
}

.request-vam-date-field ::v-deep .vpd-input-group input,
.request-vam-date-field ::v-deep .vpd-input-group input.form-control {
  flex: 1 1 auto;
  min-width: 0;
  height: calc(1.5em + 0.75rem + 2px);
  min-height: calc(1.5em + 0.75rem + 2px);
  margin: 0;
  padding: 0.375rem 0.75rem;
  border: none !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  background: transparent;
  font-size: 1rem;
  line-height: 1.5;
}

.request-vam-date-field ::v-deep .vpd-input-group .vpd-icon-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 2.5rem;
  margin: 0;
  padding: 0;
  border: none;
  border-right: 1px solid #ced4da;
  border-radius: 0;
  background: #f8f9fa;
}

/* ---------- Step 3: guarantors ---------- */
.request-vam-zamen-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 1.15rem 1.5rem;
  width: 100%;
}

@media (min-width: 576px) {
  .request-vam-zamen-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    row-gap: 1.25rem;
  }

  .request-vam-zamen-slot--solo {
    grid-column: 1 / -1;
  }
}

.request-vam-zamen-slot {
  min-width: 0;
  width: 100%;
}

.request-vam-zamen-input-group {
  display: flex;
  align-items: stretch;
  width: 100%;
  height: 40px;
  overflow: hidden;
  border: 1px solid #dbe5eb;
  border-radius: 10px;
  background: #fff;
  direction: rtl;
  transition: border-color 0.18s ease, box-shadow 0.18s ease;
}

.request-vam-zamen-input-group:hover {
  border-color: #bdcbd4;
}

.request-vam-zamen-input-group:focus-within {
  border-color: #05b8c8;
  box-shadow: 0 0 0 4px rgba(5, 184, 200, 0.2);
}

.request-vam-zamen-code {
  flex: 1 1 auto;
  min-width: 0;
  height: 100% !important;
  padding: 0 0.8rem !important;
  border: none !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  background: transparent !important;
  font-size: 13px;
  text-align: left;
  direction: ltr;
}

.request-vam-zamen-code::placeholder {
  color: #9aa8b5;
  text-align: right;
  direction: rtl;
}

.request-vam-zamen-code:focus {
  box-shadow: none !important;
}

.request-vam-zamen-check-btn {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 4.5rem;
  padding: 0 1rem;
  border: none;
  border-right: 1px solid #dbe5eb;
  border-radius: 0;
  background: #edf7fb;
  color: #29345f;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 12.5px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.18s ease;
}

.request-vam-zamen-check-btn:hover {
  background: #dcf0f6;
}

.request-vam-zamen-check-btn:focus {
  outline: none;
}

.request-vam-zamen-check-btn:focus-visible {
  background: #dcf0f6;
  box-shadow: inset 0 0 0 2px #05b8c8;
}

.request-vam-zamen-ramz {
  margin-top: 0.85rem;
}

.request-vam-zamen-result {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  margin-top: 0.6rem;
  padding: 0.4rem 0.5rem 0.4rem 0.75rem;
  border: 1px solid rgba(40, 167, 69, 0.25);
  border-radius: 10px;
  background: #f6fcf8;
  font-size: 13px;
  text-align: right;
}

.request-vam-zamen-result > i {
  flex-shrink: 0;
  color: #28a745;
  font-size: 13px;
}

.request-vam-zamen-result__label {
  flex-shrink: 0;
  color: #6b7b8e;
}

.request-vam-zamen-result__name {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  color: #29345f;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.request-vam-zamen-result__remove {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: #8091a3;
  font-size: 12px;
  cursor: pointer;
  transition: background 0.18s ease, color 0.18s ease;
}

.request-vam-zamen-result__remove:hover {
  background: #fcefed;
  color: #b44f46;
}

.request-vam-zamen-result__remove:focus {
  outline: none;
}

.request-vam-zamen-result__remove:focus-visible {
  box-shadow: 0 0 0 3px rgba(5, 184, 200, 0.3);
}

/* shared small pieces (steps 3 & 4) */
.vam-hint {
  display: block;
  margin-top: 0.4rem;
  font-size: 12px;
  line-height: 1.7;
  color: #b44f46;
}

.vam-notice {
  display: flex;
  align-items: flex-start;
  gap: 0.6rem;
  padding: 0.85rem 1.1rem;
  border: 1px solid #eef2f5;
  border-right: 3px solid #287db4;
  border-radius: 14px;
  background: #f9fbfc;
  color: #3b4a5c;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px;
  line-height: 1.9;
  text-align: right;
}

.vam-notice > i {
  flex-shrink: 0;
  margin-top: 0.35rem;
  font-size: 13px;
  color: #287db4;
}

.vam-notice--warning {
  border-right-color: #c48726;
}

.vam-notice--warning > i {
  color: #c48726;
}

.vam-notice__link {
  padding: 0 2px;
  color: #287db4;
  font-weight: 700;
  text-decoration: underline;
  text-underline-offset: 3px;
}

/* ---------- Step 4: upload ---------- */
.request-vam-upload-section > * + * {
  margin-top: 1rem;
}

.request-vam-upload-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  width: 100%;
  padding: 1.75rem 1rem 1.5rem;
  border: 1.5px dashed #bdcbd4;
  border-radius: 14px;
  background: #f9fbfc;
  text-align: center;
}

.request-vam-upload-card__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  margin-bottom: 0.35rem;
  border-radius: 14px;
  background: #edf7fb;
  color: #287db4;
  font-size: 20px;
  line-height: 1;
}

.request-vam-upload-card__title {
  margin: 0;
  font-size: 14px;
  font-weight: 700;
  color: #29345f;
}

.request-vam-upload-card__hint {
  margin: 0;
  font-size: 12px;
  line-height: 1.6;
  color: #6b7b8e;
}

.request-vam-upload-card__meta {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  max-width: 100%;
  margin-top: 0.6rem;
  padding: 0.45rem 0.8rem;
  border: 1px solid #e8eef2;
  border-radius: 10px;
  background: #fff;
  font-size: 13px;
  text-align: right;
}

.request-vam-upload-card__meta > i {
  flex-shrink: 0;
  color: #287db4;
}

.request-vam-upload-card__file {
  min-width: 0;
  overflow: hidden;
  color: #13243a;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.request-vam-upload-card__size {
  flex-shrink: 0;
  font-size: 12px;
  color: #6b7b8e;
}

.request-vam-upload-card__btn {
  min-height: 40px;
  margin-top: 0.6rem;
  padding: 0 1.4rem;
  border: 1px solid #29345f;
  border-radius: 12px;
  background: #fff;
  color: #29345f;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.18s ease;
}

.request-vam-upload-card__btn:hover {
  background: #f1f3f9;
}

.request-vam-upload-card__btn:focus {
  outline: none;
}

.request-vam-upload-card__btn:focus-visible {
  box-shadow: 0 0 0 4px rgba(5, 184, 200, 0.2);
}

/* ---------- Step 5: final review ---------- */
.request-vam-review > * + * {
  margin-top: 1rem;
}

.request-vam-review-intro {
  margin: 0;
  font-size: 13px;
  line-height: 1.9;
  color: #6b7b8e;
  text-align: right;
}

/* hero summary */
.request-vam-review-hero {
  padding: 1.1rem 1.25rem 1.15rem;
  border-radius: 18px;
  color: #fff;
  text-align: center;
  background: radial-gradient(
      circle at 15% 20%,
      rgba(5, 184, 200, 0.24),
      transparent 32%
    ),
    radial-gradient(
      circle at 90% 80%,
      rgba(141, 88, 164, 0.28),
      transparent 38%
    ),
    linear-gradient(155deg, #4a4584 0%, #29345f 62%, #20254c 100%);
  box-shadow: 0 12px 24px rgba(41, 52, 95, 0.18);
}

.request-vam-review-hero__top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
}

.request-vam-review-hero__name {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  min-width: 0;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.6;
  color: rgba(232, 242, 248, 0.88);
  text-align: right;
}

.request-vam-review-hero__name i {
  flex-shrink: 0;
  color: #3cb9dd;
}

.request-vam-review-hero__edit,
.request-vam-review-panel__edit {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  flex-shrink: 0;
  padding: 0.3rem 0.7rem;
  border: 0;
  border-radius: 999px;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.18s ease;
}

.request-vam-review-hero__edit i,
.request-vam-review-panel__edit i {
  font-size: 10px;
}

.request-vam-review-hero__edit {
  background: rgba(255, 255, 255, 0.14);
  color: #fff;
}

.request-vam-review-hero__edit:hover {
  background: rgba(255, 255, 255, 0.24);
}

.request-vam-review-hero__amount {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  justify-content: center;
  gap: 0.4rem;
  margin-top: 0.9rem;
  direction: ltr;
}

.request-vam-review-hero__amount span {
  min-width: 0;
  font-size: 30px;
  font-weight: 800;
  line-height: 1.3;
  letter-spacing: 0.2px;
  overflow-wrap: anywhere;
}

.request-vam-review-hero__amount small {
  font-size: 13px;
  font-weight: 500;
  color: rgba(232, 242, 248, 0.76);
}

.request-vam-review-hero__caption {
  display: block;
  font-size: 12px;
  color: rgba(232, 242, 248, 0.76);
}

.request-vam-review-hero__stats {
  display: flex;
  flex-wrap: wrap;
  margin-top: 1rem;
  padding-top: 0.9rem;
  border-top: 1px solid rgba(255, 255, 255, 0.14);
}

.request-vam-review-hero__stat {
  flex: 1 1 0;
  min-width: 120px;
  padding: 0.25rem 0.5rem;
}

.request-vam-review-hero__stat + .request-vam-review-hero__stat {
  border-right: 1px solid rgba(255, 255, 255, 0.14);
}

.request-vam-review-hero__stat-label {
  display: block;
  font-size: 12px;
  color: rgba(232, 242, 248, 0.7);
}

.request-vam-review-hero__stat-value {
  display: block;
  margin-top: 2px;
  font-size: 14px;
  font-weight: 700;
  unicode-bidi: isolate;
}

/* panels */
/* flat sections: hairline separators instead of boxes */
.request-vam-review-panel {
  padding: 1.1rem 0 0;
  border: 0;
  border-top: 1px solid #e8eef2;
  border-radius: 0;
  background: transparent;
}

.request-vam-review-panel__header {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  margin-bottom: 0.85rem;
}

.request-vam-review-panel__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 30px;
  height: 30px;
  border-radius: 9px;
  background: #edf7fb;
  color: #287db4;
  font-size: 13px;
}

.request-vam-review-panel__title {
  flex: 1 1 auto;
  margin: 0;
  font-size: 14px;
  font-weight: 800;
  color: #29345f;
  text-align: right;
}

.request-vam-review-panel__edit {
  background: #f4f7f9;
  color: #29345f;
}

.request-vam-review-panel__edit:hover {
  background: #e9eff2;
}

.request-vam-review-hero__edit:focus,
.request-vam-review-panel__edit:focus {
  outline: none;
}

.request-vam-review-hero__edit:focus-visible,
.request-vam-review-panel__edit:focus-visible {
  box-shadow: 0 0 0 3px rgba(5, 184, 200, 0.35);
}

.request-vam-review-empty {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.7rem 0.9rem;
  border-radius: 10px;
  background: #f9fbfc;
  color: #6b7b8e;
  font-size: 13px;
  text-align: right;
}

.request-vam-review-empty--danger {
  background: #fcefed;
  color: #b44f46;
  font-weight: 600;
}

/* guarantors */
.request-vam-review-guarantor-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.request-vam-review-guarantor-card {
  overflow: hidden;
  border: 0;
  border-radius: 12px;
  background: #f9fbfc;
}

.request-vam-review-guarantor-card__header {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  padding: 0.65rem 0.9rem 0.35rem;
  background: transparent;
  text-align: right;
}

.request-vam-review-guarantor-card__badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: linear-gradient(145deg, #05b8c8, #8d58a4);
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
}

.request-vam-review-guarantor-card__title {
  flex: 1;
  min-width: 0;
  font-size: 14px;
  font-weight: 700;
  color: #29345f;
  word-break: break-word;
}

.request-vam-review-guarantor-card__grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 0 1.5rem;
  padding: 0.25rem 0.9rem 0.4rem;
}

@media (min-width: 576px) {
  .request-vam-review-guarantor-card__grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .request-vam-review-field--full {
    grid-column: 1 / -1;
  }
}

.request-vam-review-field {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  min-width: 0;
  width: 100%;
  padding: 0.5rem 0;
  border-bottom: 1px solid #eaf0f3;
  direction: rtl;
  text-align: right;
}

.request-vam-review-field--full {
  align-items: flex-start;
  border-bottom: none;
}

.request-vam-review-field__label {
  flex: 0 0 auto;
  font-size: 12.5px;
  color: #6b7b8e;
  line-height: 1.6;
  white-space: nowrap;
}

.request-vam-review-field__value {
  flex: 1 1 auto;
  min-width: 0;
  font-size: 13px;
  font-weight: 600;
  color: #13243a;
  line-height: 1.6;
  text-align: left;
  word-break: break-word;
}

.request-vam-review-field--full .request-vam-review-field__value {
  text-align: right;
}

.request-vam-review-field__value--ltr {
  direction: ltr;
  unicode-bidi: isolate;
  text-align: left;
}

/* attachment */
.request-vam-review-file {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.6rem 0.9rem;
  border: 0;
  border-radius: 10px;
  background: #f9fbfc;
  font-size: 13px;
  text-align: right;
}

.request-vam-review-file > i {
  flex-shrink: 0;
  color: #287db4;
}

.request-vam-review-file__name {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  color: #13243a;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.request-vam-review-file__size {
  flex-shrink: 0;
  font-size: 12px;
  color: #6b7b8e;
}

/* terms checkbox (customer 932) */
.request-vam-review-terms {
  align-items: flex-start;
}

.request-vam-review-terms label {
  margin: 0;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.9;
  color: #3b4a5c !important;
  cursor: pointer;
}

.request-vam-review-terms input[type="checkbox"] {
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  margin-top: 0.4rem;
  accent-color: #c48726;
  cursor: pointer;
}

@media (max-width: 575px) {
  .request-vam-review-hero__amount span {
    font-size: clamp(20px, 7vw, 26px);
  }

  .request-vam-review-hero__stat {
    flex: 1 1 100%;
    padding: 0.4rem 0;
  }

  .request-vam-review-hero__stat + .request-vam-review-hero__stat {
    border-right: 0;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
  }
}

/* ---------- Step navigation buttons (NetPa design system) ---------- */
.request-vam-step-nav {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  width: 100%;
  margin-top: 1.75rem;
  padding-top: 1.25rem;
  border-top: 1px solid #e8eef2;
  direction: rtl;
}

/* align with the centered 680px content column of steps 1–5 */
.request-vam-step-nav--narrow {
  width: min(calc(100% - 1rem), calc(680px - 1rem));
  margin-right: auto;
  margin-left: auto;
}

.request-vam-step-nav--next-only {
  justify-content: flex-end;
}

.request-vam-step-nav__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  min-width: 8.5rem;
  min-height: 46px;
  padding: 0 1.5rem;
  border: 1px solid transparent;
  border-radius: 14px;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.25;
  cursor: pointer;
  transition: transform 0.18s ease, box-shadow 0.18s ease,
    background-color 0.18s ease, border-color 0.18s ease, opacity 0.18s ease;
}

.request-vam-step-nav__btn i {
  font-size: 12px;
}

.request-vam-step-nav__btn:focus {
  outline: none;
}

.request-vam-step-nav__btn:focus-visible {
  box-shadow: 0 0 0 4px rgba(5, 184, 200, 0.2);
}

.request-vam-step-nav__btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  box-shadow: none;
  transform: none;
}

/* secondary */
.request-vam-step-nav__btn--prev {
  color: #29345f;
  background: #fff;
  border-color: #dbe5eb;
}

.request-vam-step-nav__btn--prev:hover:not(:disabled) {
  background: #f4f7f9;
  border-color: #bdcbd4;
}

/* primary */
.request-vam-step-nav__btn--next,
.request-vam-step-nav__btn--submit {
  color: #fff;
  background: linear-gradient(110deg, #29345f, #56508d 58%, #8d58a4);
  box-shadow: 0 8px 18px rgba(41, 52, 95, 0.22);
}

.request-vam-step-nav__btn--next:hover:not(:disabled),
.request-vam-step-nav__btn--submit:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 12px 24px rgba(41, 52, 95, 0.26);
}

.request-vam-step-nav__btn--next:active:not(:disabled),
.request-vam-step-nav__btn--submit:active:not(:disabled) {
  transform: translateY(0);
}

.request-vam-step-nav__btn--next:focus-visible,
.request-vam-step-nav__btn--submit:focus-visible {
  box-shadow: 0 8px 18px rgba(41, 52, 95, 0.22), 0 0 0 4px rgba(5, 184, 200, 0.3);
}

@media (max-width: 575px) {
  .request-vam-step-nav {
    flex-wrap: nowrap;
  }

  .request-vam-step-nav__btn {
    flex: 1 1 0;
    min-width: 0;
    padding: 0 0.75rem;
  }
}

@media (prefers-reduced-motion: reduce) {
  .request-vam-step-nav__btn {
    transition: none;
  }

  .request-vam-step-nav__btn:hover {
    transform: none !important;
  }
}

@media (hover: none) {
  .request-vam-step-nav__btn:hover {
    transform: none !important;
  }
}

@media (pointer: coarse) {
  .request-vam-zamen-result__remove {
    width: 40px;
    height: 40px;
  }

  .request-vam-review-hero__edit,
  .request-vam-review-panel__edit {
    min-height: 40px;
    padding: 0.4rem 0.9rem;
  }
}

/* ---------- Step 1: loan type picker ---------- */
.request-vam-type-list {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 0.75rem;
  width: 100%;
  max-width: 680px;
  margin: 0 auto;
  padding: 0.5rem 0.5rem 0;
  box-sizing: border-box;
}

.request-vam-type-card {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1rem;
  width: 100%;
  margin: 0;
  padding: 1rem 1.15rem;
  border: 1px solid #dbe5eb;
  border-radius: 14px;
  background: #fff;
  color: #13243a;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  text-align: right;
  cursor: pointer;
  appearance: none;
  transition: border-color 0.18s ease, background-color 0.18s ease,
    box-shadow 0.18s ease;
}

.request-vam-type-card:hover {
  border-color: #bdcbd4;
  background: #fbfdfd;
}

.request-vam-type-card:focus {
  outline: none;
}

.request-vam-type-card:focus-visible {
  border-color: #05b8c8;
  box-shadow: 0 0 0 4px rgba(5, 184, 200, 0.2);
}

.request-vam-type-card--selected,
.request-vam-type-card--selected:hover {
  border-color: rgba(40, 167, 69, 0.45);
  background: #f6fcf8;
  box-shadow: inset -3px 0 0 #28a745;
  cursor: default;
}

.request-vam-type-card__radio {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 22px;
  height: 22px;
  border: 1.5px solid #cfd8de;
  border-radius: 50%;
  background: #fff;
  color: transparent;
  font-size: 10px;
  transition: background-color 0.18s ease, border-color 0.18s ease,
    color 0.18s ease;
}

.request-vam-type-card:hover .request-vam-type-card__radio {
  border-color: #28a745;
}

.request-vam-type-card--selected .request-vam-type-card__radio {
  border-color: #28a745;
  background: #28a745;
  color: #fff;
}

.request-vam-type-card__info {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  flex: 1;
  min-width: 0;
}

.request-vam-type-card__title {
  font-size: 14px;
  font-weight: 700;
  line-height: 1.6;
  color: #29345f;
}

.request-vam-type-card__desc {
  font-size: 12.5px;
  line-height: 1.8;
  color: #6b7b8e;
}

/* ---------- Step 2: minimal form (NetPa design system tokens) ---------- */
.vam-section {
  --bnp-brand-navy: #29345f;
  --bnp-brand-cyan: #05b8c8;
  --bnp-text-primary: #13243a;
  --bnp-text-secondary: #6b7b8e;
  --bnp-border-default: #dbe5eb;
  --bnp-border-subtle: #e8eef2;
  --bnp-border-hover: #bdcbd4;
  --bnp-focus-ring: 0 0 0 4px rgba(5, 184, 200, 0.2);

  width: 100%;
  max-width: 680px;
  margin: 0 auto;
  padding: 0.5rem 0.5rem 0;
  box-sizing: border-box;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
}

/* grid: 1 col on mobile, 2 cols from tablet up — plenty of air */
.vam-section .request-vam-form-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 1rem 1.5rem;
  width: 100%;
  margin: 0;
}

.vam-section .request-vam-form-grid > [class*="col-"] {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  flex: none;
  padding: 0 !important;
}

@media (min-width: 576px) {
  .vam-section .request-vam-form-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    row-gap: 1.25rem;
  }
}

/* reading order: amount · date / count · installment / payment · account */
.vam-f-amount {
  order: 1;
}
.vam-f-date {
  order: 2;
}
.vam-f-count {
  order: 3;
}
.vam-f-installment {
  order: 4;
}
.vam-f-pay {
  order: 5;
}
.vam-f-account {
  order: 6;
}
.vam-f-extra {
  order: 7;
}

.vam-section label {
  display: block;
  margin-bottom: 0.4rem;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.5;
  color: var(--bnp-text-secondary) !important;
}

.vam-section .form-control {
  height: 40px;
  padding: 0 0.8rem;
  border: 1px solid var(--bnp-border-default);
  border-radius: 10px;
  background-color: #fff;
  color: var(--bnp-text-primary);
  font-family: inherit;
  font-size: 13px;
  box-shadow: none;
  transition: border-color 0.18s ease, box-shadow 0.18s ease,
    background-color 0.18s ease;
}

.vam-section .form-control:hover:not(:disabled) {
  border-color: var(--bnp-border-hover);
}

.vam-section .form-control:focus {
  border-color: var(--bnp-brand-cyan);
  box-shadow: var(--bnp-focus-ring);
}

.vam-section .form-control:disabled,
.vam-section .form-control[disabled] {
  background-color: #f6f8fa;
  border-color: var(--bnp-border-subtle);
  color: var(--bnp-brand-navy);
  font-weight: 600;
  opacity: 0.85;
  cursor: not-allowed;
}

.vam-section select.form-control {
  padding: 0 0.6rem;
}

.vam-section .btn.btn-primary {
  min-height: 34px;
  margin-top: 0.5rem;
  border: 0;
  border-radius: 10px;
  background: linear-gradient(110deg, #29345f, #56508d 58%, #8d58a4);
  font-family: inherit;
  font-size: 12px;
  font-weight: 700;
}

.request-vam-date-field ::v-deep .vpd-input-group {
  height: 40px;
  min-height: 40px;
  border-color: #e8eef2;
  border-radius: 10px;
  background: #f6f8fa;
}

.request-vam-date-field ::v-deep .vpd-input-group input,
.request-vam-date-field ::v-deep .vpd-input-group input.form-control {
  height: 38px;
  min-height: 38px;
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  color: #29345f;
}

.request-vam-date-field ::v-deep .vpd-input-group .vpd-icon-btn {
  border-right-color: #e8eef2;
  background: #eff3f6;
}

/* ----- info panels: quiet, neutral ----- */
.request-vam-info-cards {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 1rem;
  width: 100%;
  max-width: 680px;
  margin: 1.75rem auto 0;
}

.request-vam-info-card {
  width: 100%;
  min-width: 0;
  height: 100%;
  text-align: right;
}

.vam-info {
  padding: 1rem 1.25rem;
  border: 1px solid #eef2f5;
  border-right: 3px solid #c48726;
  border-radius: 14px;
  background: #f9fbfc;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
}

.vam-info--notes {
  border-right-color: #287db4;
}

.vam-info__header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
  font-size: 13px;
  font-weight: 700;
  color: #6b7b8e;
}

.vam-info__header i {
  font-size: 13px;
  color: #c48726;
}

.vam-info--notes .vam-info__header i {
  color: #287db4;
}

.vam-info__rows {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 0 2rem;
  margin: 0;
  padding: 0;
  list-style: none;
}

.vam-info__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  min-width: 0;
  padding: 0.55rem 0;
  border-bottom: 1px solid #eaf0f3;
}

.vam-info__label {
  font-size: 13px;
  line-height: 1.5;
  color: #6b7b8e;
}

.vam-info__value {
  flex-shrink: 0;
  font-size: 13px;
  font-weight: 700;
  color: #29345f;
  direction: ltr;
  unicode-bidi: isolate;
}

.vam-info__value small {
  margin-right: 4px;
  font-size: 11px;
  font-weight: 500;
  color: #8091a3;
}

.vam-info__text {
  margin: 0 0 0.4rem;
  font-size: 13px;
  line-height: 1.9;
  color: #3b4a5c;
}

.vam-info__text:last-child {
  margin-bottom: 0;
}

.vam-info__list {
  margin: 0;
  padding: 0 1.1rem 0 0;
  font-size: 13px;
  line-height: 1.9;
  color: #3b4a5c;
  list-style: disc;
}

.request-vam-info-card__block + .request-vam-info-card__block {
  margin-top: 0.75rem;
  padding-top: 0.75rem;
  border-top: 1px solid #eaf0f3;
}

.request-vam-info-card__subtitle {
  margin-bottom: 0.35rem;
  font-size: 13px;
  font-weight: 700;
  color: #29345f;
}
</style>
<style>
.request-vam-content,
.request-vam-step-panel,
.request-vam-type-list,
.request-vam-type-card {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

/* ---------- Minimal stepper ---------- */
.vam-stepper {
  width: 100%;
  padding: 0.35rem 0.25rem;
  overflow-x: auto;
  scrollbar-width: none;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  box-sizing: border-box;
}

.vam-stepper::-webkit-scrollbar {
  display: none;
}

.vam-stepper__list {
  display: flex;
  align-items: center;
  margin: 0;
  padding: 0;
  list-style: none;
}

.vam-stepper__item {
  display: flex;
  align-items: center;
  flex: 0 0 auto;
  min-width: 0;
}

.vam-stepper__item:not(.vam-stepper__item--last) {
  flex: 1 1 auto;
}

/* connector line toward the next step */
.vam-stepper__item:not(.vam-stepper__item--last)::after {
  content: "";
  flex: 1 1 auto;
  min-width: 16px;
  height: 2px;
  margin: 0 0.6rem;
  border-radius: 2px;
  background: #e3e8ef;
  transition: background 0.25s ease;
}

.vam-stepper__item--completed:not(.vam-stepper__item--last)::after {
  background: #28a745;
}

.vam-stepper__btn {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  padding: 0.2rem 0.1rem;
  border: none;
  background: transparent;
  color: #6c757d;
  font-family: inherit;
  cursor: pointer;
  white-space: nowrap;
  min-width: 0;
  max-width: 100%;
}

.vam-stepper__btn:focus {
  outline: none;
}

.vam-stepper__btn:focus-visible .vam-stepper__circle {
  outline: 2px solid rgba(42, 63, 84, 0.35);
  outline-offset: 2px;
}

.vam-stepper__circle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 1.5px solid #cfd6df;
  background: #fff;
  color: #6c757d;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
  transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease;
}

.vam-stepper__circle .fa-check {
  font-size: 10px;
}

.vam-stepper__label {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.3;
  color: #6c757d;
  transition: color 0.2s ease;
}

/* Completed */
.vam-stepper__item--completed .vam-stepper__circle {
  background: #28a745;
  border-color: #28a745;
  color: #fff;
}

.vam-stepper__item--completed .vam-stepper__label {
  color: #2a3f54;
}

/* Active */
.vam-stepper__item--active .vam-stepper__circle {
  background: #28a745;
  border-color: #28a745;
  color: #fff;
  box-shadow: 0 0 0 3px rgba(40, 167, 69, 0.18);
}

.vam-stepper__item--active .vam-stepper__label {
  color: #2a3f54;
  font-weight: 700;
}

/* Hover (clickable only) */
.vam-stepper__btn:not(:disabled):hover .vam-stepper__circle {
  border-color: #28a745;
}

.vam-stepper__btn:not(:disabled):hover .vam-stepper__label {
  color: #2a3f54;
}

/* Locked */
.vam-stepper__btn:disabled {
  cursor: not-allowed;
}

.vam-stepper__item--locked:not(.vam-stepper__item--active):not(.vam-stepper__item--completed) .vam-stepper__circle {
  background: #f0f2f5;
  border-color: #e3e8ef;
  color: #aab3bf;
}

.vam-stepper__item--locked:not(.vam-stepper__item--active):not(.vam-stepper__item--completed) .vam-stepper__label {
  color: #aab3bf;
  font-weight: 500;
}

/* compact: show the label only for the current step */
.vam-stepper--compact
  .vam-stepper__item:not(.vam-stepper__item--active)
  .vam-stepper__label {
  display: none;
}

.vam-stepper--compact .vam-stepper__item:not(.vam-stepper__item--last)::after {
  min-width: 8px;
  margin: 0 0.3rem;
}

.vam-stepper--compact .vam-stepper__item--active {
  flex-shrink: 0;
}

@media (pointer: coarse) {
  .vam-stepper__btn {
    min-height: 44px;
  }
}
</style>
